import type { AnnouncementMeta } from '@app/store/types/announcements'

export const defaultAnnouncementMeta: AnnouncementMeta = { updating: false, error: null }
